// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"981287bc","254":"7b150d33","386":"b4213d62","453":"55c6a67c","473":"fab12619","625":"b8dccc04","819":"93239f65","863":"6777052e","868":"a374092a","961":"8762f299","980":"74f1fa7c"}[chunkId] + ".chunk.js";
};